import { z } from "zod";

import { COACH_CURRENCIES } from "~/lib/shared/constants/currencies";
import {
  invalidAmountMessage,
  isValidAmountForCurrency,
} from "~/lib/shared/currency";

// Stripe rejects a due_date that isn't strictly in the future, so validate it
// at the boundary (surfacing a clear field error) instead of letting the
// Stripe call 500.
export const InvoiceDueDateSchema = z
  .date()
  .refine((d) => d.getTime() > Date.now(), {
    message: "Due date must be in the future.",
  });

/** A coach's new invoice, as typed: the amount is in the currency's major unit. */
export const CreateInvoiceSchema = z
  .object({
    customerName: z.string().trim().min(1),
    customerEmail: z.string().trim().email(),
    description: z.string().min(1),
    amount: z.number({ message: "Enter an amount." }).positive(),
    currency: z.enum(COACH_CURRENCIES),
    dueDate: z.string().refine((date) => {
      const parsed = new Date(date);
      if (!Number.isFinite(parsed.getTime())) return false;

      const tomorrow = new Date();
      tomorrow.setUTCHours(0, 0, 0, 0);
      tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
      return parsed >= tomorrow;
    }, "Due date must be at least tomorrow"),
  })
  .superRefine((invoice, ctx) => {
    if (isValidAmountForCurrency(invoice.amount, invoice.currency)) return;
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      path: ["amount"],
      message: invalidAmountMessage(invoice.currency),
    });
  });
